import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { SxProps } from '@mui/material/styles';

import { withSxProp } from 'common/utils/props';

interface IProps {
    children?: React.ReactNode;
    description: React.ReactNode;
    descriptionSx?: SxProps;
}

export const InfoRow = ({ children, description, descriptionSx }: IProps) => (
    <Box>
        <Grid container spacing={{ xs: 1.5, sm: 1 }} sx={{ lineHeight: 1.2 }}>
            <Grid
                size={{ sm: 3, xs: 12 }}
                sx={[{ fontWeight: 'bold' }, ...withSxProp(descriptionSx)]}
            >
                {description}
            </Grid>
            {children && <Grid size="grow">{children}</Grid>}
        </Grid>
    </Box>
);
